export default __webpack_public_path__ + "static/media/arrow_down.53594206.svg";